import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import routes from "../../routes";
import { subRouteMapping } from "../../constant/subRoutes";
import Regularonboarding from "./Regularonboarding";
import { onboardingServices } from "../../services/onboardingServices";
import { Backdrop, CircularProgress } from "@mui/material";
import { vendorServices } from "../../services/vendorServices";
import _ from "lodash";
import { adminServices } from "../../services/adminServices";
import AlertComponent from "../alert/alert";

function StepAssignee() {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [regulartabs, setRegularTabs] = useState("REGULAR_ONBOARDING");
  const [tabArr, setTabArr] = useState([]);
  const [sectionAssignData, setSectionAssignData] = useState([]);
  const [configSubRoute, setConfigSubRoute] = useState([]);
  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });

  useEffect(() => {
    getAdminStep("REGULAR_ONBOARDING");
    getAssignSteps();
    setConfigSubRoute(subRouteMapping(routes, "CONFIGURATION"));
  }, []);

  const getAdminStep = (data) => {
    setIsLoading(true);
    let param = `?onboardingType=${data}`;
    onboardingServices
      .getAdminStep(param)
      .then(function (response) {
        if (response.data.success == true) {
          let arr = [...response?.data?.data];
          setTabArr(arr);

        } else {
          setTabArr([]);
        }
      })
      .catch(function (error) {
        setTabArr([]);
        openAlert(true, 'error', `${error?.response?.data?.message}`);
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };

  const getAssignSteps = (param) => {
    setIsLoading(true);
    return vendorServices
      .getAssignSteps(param)
      .then(function (response) {
        if (response.data.success === true) {
          setSectionAssignData(response?.data?.data?.assignees);
        }
      })
      .catch(function (error) {
        openAlert(true, 'error', `${error?.response?.data?.message}`);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const onOnboardingChange = (e) => {
    setRegularTabs(e.target.value);
    getAdminStep(e.target.value);
  };

  const onAssigneeChange = (value, row, index) => {
    setIsLoading(true);
    let bodyData = {
      "assigneeId": value,
      "onboardingType": regulartabs
    };

    adminServices.adminStepAssign(bodyData, row?._id)
      .then(function (response) {
        if (response.data.success === true) {
          // setSectionAssignData(response?.data?.data?.assignees);        
          let tabArrInit = _.cloneDeep(tabArr);
          tabArrInit[index].defaultAssignee = value;
          setTabArr(tabArrInit);
          openAlert(true, 'success', `${response?.data?.message}`);
        }
      })
      .catch(function (error) {
        openAlert(true, 'error', `${error?.response?.data?.message}`);
      })
      .finally(() => {
        setIsLoading(false);
      });

  };

  const openAlert = (open, type, message) => {
    setAlertComponent({ open, type, message });
  };

  const handleCloseAlert = (event, reason) => {
    setAlertComponent({ ...alertComponent, open: false });
  };

  return (
    <>
      <div class="login-forms">
        <div class="text-centers">
          <div class="heading_search_outer d sub-route-upper-sec">
            <div>
              <div className="sub-route-sec">
                {configSubRoute.map(
                  (ele, i) =>
                    ele.isSubRoute && (
                      <div
                        className={
                          location.pathname.indexOf(ele.path) !== -1
                            ? "sub-route-sec-div sub-route-sec-div-active"
                            : "sub-route-sec-div"
                        }
                      >
                        <Link to={ele.layout + ele.path}>{ele.name}</Link>
                        {/* <p>Existing Vendor</p> */}
                      </div>
                    )
                )}
              </div>
            </div>
          </div>
          <div className="lets_block_list_assignee_panel">
                <div className="listing_block_react_control_panel">
                  <label className="control_panel_react_listing_onboarding">
                    Onboarding Type
                  </label>
                  <select
                    id="onboardingType"
                    class="form-select vendor_lr_permission"
                    aria-label="Default select example"
                    fdprocessedid="5g569t"
                    value={regulartabs}
                    // value={selectedPageOption?.value}
                    onChange={onOnboardingChange}
                  >
                    <option value="REGULAR_ONBOARDING">Regular Onboarding</option>
                    <option value="DIRECT_ONBOARDING">Direct Onboarding</option>
                    <option value="ONBOARDING_WITHOUT_DOCUMENTS"> Onboarding Without Document</option>

                  </select>
                </div>
              </div>
          <Regularonboarding
            regulartabs={regulartabs}
            tabArr={tabArr}
            sectionAssignData={sectionAssignData}
            onAssigneeChange={onAssigneeChange}
          />

        </div>
      </div>
      <AlertComponent
        alertComponent={alertComponent}
        handleClose={handleCloseAlert}
      />
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}

export default StepAssignee;
